<div *ngIf="loading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div>
  <div class="panel border-[#e0e6ed] px-0 pb-1.5 dark:border-[#1b2e4b]">
    <div class="datatable invoice-table px-5">
      <div class="mb-4.5 flex flex-col gap-5 md:flex-row md:items-center">
        <app-search-input (searchChanged)="setSearchText($event)"></app-search-input>

        <div class="ltr:ml-auto rtl:mr-auto"></div>
        <a routerLink="/testemonials/form" class="btn btn-primary gap-2"> <icon-plus /> {{ "blogs.add_new" | translate }} </a>

        <div class="flex gap-4">
          <div hlMenu class="dropdown">
            <button hlMenuButton type="button" class="flex items-center rounded-md border border-[#e0e6ed] px-4 py-2 text-sm font-semibold dark:border-[#253b5c] dark:bg-[#1b2e4b] dark:text-white-dark">
              <span class="ltr:mr-1 rtl:ml-1">{{ "table_columns" | translate }}</span>
              <icon-caret-down class="h-5 w-5" />
            </button>
            <ul *hlMenuItems @toggleAnimation class="w-max ltr:left-0 rtl:right-0">
              <ng-container *ngFor="let col of cols; index as i">
                <li>
                  <div class="flex items-center px-4 py-1">
                    <label [for]="'chk-' + i" class="mb-0 cursor-pointer">
                      <input type="checkbox" [id]="'chk-' + i" class="form-checkbox" [ngModel]="!col.hide" (ngModelChange)="col.hide = $event" (change)="updateColumn(col)" />
                      <span class="ltr:ml-2 rtl:mr-2">{{ col.title }}</span>
                    </label>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>

        <div class="w-32">
          <ng-select
            [items]="languageOptions$ | async"
            (change)="onFilterChange()"
            [(ngModel)]="selectedLanguage"
            [searchable]="false"
            class="custom-multiselect"
            placeholder="{{ 'blogs.language_placeholder' | translate }}"
            bindLabel="title"
            bindValue="title"
          >
          </ng-select>
        </div>
      </div>

      <ng-datatable
        #datatable
        [rows]="items"
        [columns]="cols"
        [sortable]="true"
        [isServerMode]="true"
        [page]="pageNumber"
        [search]="search"
        [pageSize]="pageSize"
        [totalRows]="totalRows"
        [sortColumn]="sortColumn"
        [sortDirection]="sortDirection"
        (changeServer)="changeServer($event)"
        skin="whitespace-nowrap bh-table-hover"
        [paginationInfo]="'paginationInfoLabel' | translate"
        firstArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M16.9998 19L10.9998 12L16.9998 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        lastArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M11 19L17 12L11 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path opacity="0.5" d="M6.99976 19L12.9998 12L6.99976 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        previousArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M15 5L9 12L15 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
        nextArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 rtl:rotate-180"> <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
      >
        <ng-template slot="title" let-value="data">
          <div class="flex items-center font-semibold">
            {{ value.title }}
          </div>
        </ng-template>

        <ng-template slot="categoryId" let-value="data">
          <span class="badge" [ngClass]="[value.category ? (value?.category?.title?.toLowerCase() === 'paid' ? 'badge-outline-success' : 'badge-outline-danger') : '']">{{ value?.category?.title }}</span>
        </ng-template>
        <ng-template slot="created" let-value="data">
          <div class="font-semibold">
            {{ value.created | date: "dd.MM.yyyy" }}
          </div>
        </ng-template>

        <ng-template slot="updatedAt" let-value="data">
          <div class="font-semibold">
            {{ value.updatedAt | date: "dd.MM.yyyy" }}
          </div>
        </ng-template>

        <ng-template slot="actions" let-value="data">
          <div class="flex w-max items-center justify-between">
            <div hlMenu class="dropdown">
              <a hlMenuButton href="javascript:;">
                <icon-horizontal-dots class="rotate-90 opacity-70" />
              </a>
              <div #dropdownPlaceholder *hlMenuItems>
                <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                  <li>
                    <a [routerLink]="['/testemonials/form/', value.id]" *hlMenuItem="let menuItem">
                      <icon-pencil-paper class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                      {{ "edit_quick_label" | translate }}
                    </a>
                  </li>
                  <li>
                    <a href="javascript:;" *hlMenuItem="let menuItem" (click)="handleDelete(value.id)">
                      <icon-trash-lines class="shrink-0 ltr:mr-2 rtl:ml-2" />
                      {{ "delete_quick_label" | translate }}
                    </a>
                  </li>
                </app-message-portal>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-datatable>
    </div>
  </div>
</div>
